import { IUseSelectedFacility } from '../features/use-selected-facility-types'

export const showWildlifeFormForSelectedFacility = (selectedFacility: IUseSelectedFacility) => {
  return !!(
    selectedFacility?.id &&
    (selectedFacility.name?.toLowerCase().includes('wild life') ||
      selectedFacility.name?.toLowerCase().includes('wildlife'))
  )
}
